module.exports = __webpack_public_path__ + "static/media/experience-classic.02178c4a.svg";